interface Props {
  className?: string;
}
export function Logo({ className = "" }: Props) {
  return (
    <svg
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* #285E48 */}
      <path
        d="M16 65.2531L83 89V82.0278L16 58.2759V65.2531ZM60.3671 10L80.9437 62.5338L17.0111 40.8594C23.1697 33.3808 52.4538 12.4688 60.3683 10H60.3671ZM16 46.6264L83 69.313V75.914L16 52.1671V46.6264Z"
        fill="currentColor"
      />
    </svg>
  );
}
